// extracted by mini-css-extract-plugin
export default {"container":"LoaderOverlay_container__XWqBP","overlay":"LoaderOverlay_overlay__uh8DF"};